<div class="filter-zone tw-flex tw-flex-row tw-gap-3">
  <ng-container *ngTemplateOutlet="optionSelect;context:{type: 'all'}"></ng-container>
  
  <ng-container *ngIf="filters?.all?.selected!=='all'">
    <ng-container *ngTemplateOutlet="optionSelect;context:{type: filters?.all?.selected}"></ng-container>
  </ng-container>

  <ng-template #optionSelect let-type="type">
    <ng-container *ngIf="filters[type]?.selected || (multipleSelectionMode && (type === 'brands' || type === 'regions'))">
      <div class="custom-selector" [hidden]="type !== 'all' && filters?.all?.values?.length===1">
        <button
          class="tw-rounded-full md:tw-w-fit tw-w-14 tw-h-14 tw-bg-white tw-text-main tw-shadow-1 tw-flex tw-justify-center md:tw-px-7 md:tw-py-2 focus:tw-outline-0 hover:tw-bg-gray-50 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
          (click)="toggleDropdown(type)" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
          [class.!tw-bg-main]="isOpen[type]"
          [class.!tw-text-white]="isOpen[type]"
          [attr.id]="'chainSelectorTrigger-' + type"
          [disabled]="disabled"
        >
          <i class="fas fa-filter tw-self-center tw-text-lg md:tw-text-base"></i>
          <span class="tw-hidden tw-ml-2 md:tw-inline-block tw-text-base tw-font-medium tw-self-center tw-text-main-text" [class.!tw-text-white]="isOpen[type]">
            <ng-container *ngIf="type === 'all'">
              {{'shared.filters.chain-zone.types.' + filters[type].selected | translate}}
            </ng-container>
            
            <ng-container *ngIf="type !== 'all'">
              <ng-container *ngIf="!multipleSelectionMode || !(type === 'brands' || type === 'regions')">
                {{filters[type].selected}}
              </ng-container>
              <ng-container *ngIf="multipleSelectionMode && (type === 'brands' || type === 'regions')">
                <ng-container *ngIf="filters[type].selectedMultiple.length <= 2">
                  <span *ngFor="let selected of filters[type].selectedMultiple; let isLast=last">
                    {{selected}}<span *ngIf="!isLast">, </span>
                  </span>
                </ng-container>
                <ng-container *ngIf="filters[type].selectedMultiple.length > 2">
                  <span [title]="filters[type].selectedMultiple.join(', ')" class="tw-cursor-help">
                    {{'shared.filters.chain-zone.types.' + type | translate}} {{'shared.filters.chain-zone.actions.selected' | translate}} ({{filters[type].selectedMultiple.length}})
                  </span>
                </ng-container>
              </ng-container>
            </ng-container>
          </span>
        </button>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isOpen[type]"
        >
          <article class="tw-rounded-lg tw-shadow-xl tw-p-3 tw-bg-white tw-mt-1 tw-max-h-[300px] tw-overflow-y-auto tw-w-[300px]" [attr.id]="'chainSelectorMenu-' + type">
            <div class="tw-mb-2 tw-font-medium">{{'shared.filters.chain-zone.labels.'+type | translate }}</div>
            
            <ng-container *ngIf="type === 'all'">
              <mat-radio-group class="tw-flex tw-flex-col tw-w-full" [(ngModel)]="filters[type].selected" (change)="selectOption(type, $event.value)">
                <mat-radio-button class="tw-my-1" *ngFor="let value of filters[type].values" [value]="value">
                  {{'shared.filters.chain-zone.types.'+value | translate}}
                </mat-radio-button>
              </mat-radio-group>
            </ng-container>
            
            <ng-container *ngIf="type !== 'all'">
              <ng-container *ngIf="!multipleSelectionMode">
                <mat-radio-group class="tw-flex tw-flex-col tw-w-full" [(ngModel)]="filters[type].selected" (change)="selectOption(type, $event.value)">
                  <mat-radio-button class="tw-my-1" *ngFor="let value of filters[type].values" [value]="value">
                    {{value}}
                  </mat-radio-button>
                </mat-radio-group>
              </ng-container>
              
              <ng-container *ngIf="multipleSelectionMode">  
                <div class="tw-mb-3" *ngIf="filters[type].values.length > 8">
                  <input 
                    type="text" 
                    class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-blue-500"
                    [placeholder]="'shared.filters.chain-zone.actions.search_placeholder' | translate"
                    [(ngModel)]="searchTerms[type]"
                    (input)="onSearchChange(type, $event)">
                </div>
                
                <div class="tw-flex tw-gap-2 tw-mb-3">
                  <button 
                    type="button"
                    class="tw-text-xs tw-px-2 tw-py-1 tw-bg-blue-100 tw-text-blue-700 tw-rounded hover:tw-bg-blue-200 tw-transition-colors"
                    (click)="selectAll(type)"
                    *ngIf="!allSelected[type]">
                    {{'shared.filters.chain-zone.actions.select_all' | translate}}
                  </button>
                  <button 
                    type="button"
                    class="tw-text-xs tw-px-2 tw-py-1 tw-bg-gray-100 tw-text-gray-700 tw-rounded hover:tw-bg-gray-200 tw-transition-colors"
                    (click)="deselectAll(type)"
                    *ngIf="allSelected[type]">
                    {{'shared.filters.chain-zone.actions.deselect_all' | translate}}
                  </button>
                </div>
                
                <div class="tw-flex tw-flex-col tw-w-full">
                  <mat-checkbox 
                    class="tw-my-1" 
                    *ngFor="let value of filteredValues[type]" 
                    [checked]="isOptionSelected(type, value)"
                    (change)="selectOption(type, value)">
                    {{value}}
                  </mat-checkbox>
                </div>
              </ng-container>
            </ng-container>
          </article>
        </ng-template>
      </div>
    </ng-container>
  </ng-template>
</div>